var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'cl-backdrop': true,
    'cl-backdrop--invisible': _vm.invisible
  },attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }